import { render, staticRenderFns } from "./WillBeneficiariesDivorcedPeople.vue?vue&type=template&id=6b931687"
import script from "./WillBeneficiariesDivorcedPeople.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesDivorcedPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports